import { render, staticRenderFns } from "./RecoMobiles.vue?vue&type=template&id=08674d6d&scoped=true"
import script from "./RecoMobiles.vue?vue&type=script&lang=js"
export * from "./RecoMobiles.vue?vue&type=script&lang=js"
import style0 from "./RecoMobiles.vue?vue&type=style&index=0&id=08674d6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08674d6d",
  null
  
)

export default component.exports